
import { BookOpen } from "lucide-react";
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";
import { useIsMobile } from "@/hooks/use-mobile";

export function CommunityHeader() {
  const { branding } = useChurchBranding();
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col items-center text-center space-y-3 animate-fade-in mt-0">
      <div className="relative w-full">
        <div 
          className="absolute inset-0 blur-lg opacity-30 rounded-xl transform -translate-y-1"
          style={{
            background: branding 
              ? `linear-gradient(to right, ${branding.primaryColor}, ${branding.secondaryColor})`
              : 'linear-gradient(to right, #362F3C, #272D42)'
          }}
        />
        <div className="relative flex items-center gap-3 bg-dark-card/80 backdrop-blur-sm px-4 py-4 rounded-xl shadow-md border border-dark-border">
          <div className="flex-shrink-0 flex justify-start items-center pl-1">
            {branding?.logoUrl ? (
              <img 
                src={branding.logoUrl}
                alt={`${branding.churchName} Logo`}
                className="h-10 sm:h-12 md:h-14 w-auto transform hover:scale-105 transition-transform"
              />
            ) : (
              <img 
                src="/lovable-uploads/97cec83c-b4fa-48c3-a12a-a678346efa1f.png" 
                alt="Logo" 
                className="h-10 sm:h-12 md:h-14 w-auto transform hover:scale-105 transition-transform"
              />
            )}
          </div>
          <div className="flex flex-col items-start text-left">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight text-white">
              Community
            </h1>
            <p className="text-xs sm:text-sm text-blue-300">
              Connect, share, and grow together in faith
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
